import { googleMapsAddressUrl, googleMapsDistanceUrl } from "../../../shared/constants/apiUrls";
import { baseApi } from "./baseApi";

export const googleMapsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchAddress: builder.query({
            query: ({ lat, lng }) => {
                const params = new URLSearchParams({ lat, lng }).toString();
                return {
                    url: `${googleMapsAddressUrl}?${params}`,
                    method: "GET",
                };
            },
            providesTags: [{type: "Address", id: "ADDRESS"}]
        }),
        fetchDistance: builder.query({
            query: ({ lat1, lng1, lat2, lng2 }) => {
                const params = new URLSearchParams({ lat1, lng1, lat2, lng2 }).toString();
                return {
                    url: `${googleMapsDistanceUrl}?${params}`,
                    method: "GET",
                };
            },
            providesTags: [{type: "Address", id: "DISTANCE"}]
        }),
    }),
});

export const { useLazyFetchAddressQuery, useLazyFetchDistanceQuery } = googleMapsApi;